import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { NEWS_FEATURE_KEY } from './keys';
import { EffectsModule } from '@ngrx/effects';
import { newsReducer } from './reducers/news.reducer';
import { NewsEffects } from './effects/news.effects';

@NgModule({
    imports: [CommonModule, StoreModule.forFeature(NEWS_FEATURE_KEY, newsReducer), EffectsModule.forFeature([NewsEffects])],
})
export class NewsStoreModule {}
